import { Component, effect, inject, input, output, signal } from '@angular/core';

import { LocalStorageService } from '@core/common-legacy';
import { HexagonsComponent } from '@core/impact-tracker-ui';
import { IconButtonComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-impact-tracker-banner',
  templateUrl: 'banner-component.html',
  styleUrl: './banner-component.less',
  imports: [IconButtonComponent, HexagonsComponent],
})
export class BannerComponent {
  private readonly localStorageService = inject(LocalStorageService);
  public subheading = input.required<string>();
  public headingHTML = input.required<string>();
  public lsKey = input.required<string>();
  public lsExpirationInterval = input<number>(); // in ms e.g. Date.now()

  public dismissed = output();

  protected isDismissed = signal<null | number>(null);

  private cacheVisibilityState = effect(() => {
    this.localStorageService.set(this.lsKey(), this.isDismissed());
  });

  protected ngOnInit() {
    this.handleDismissExpiration();
  }

  protected dismiss() {
    this.isDismissed.set(Date.now());
    this.dismissed.emit();
  }

  private handleDismissExpiration(): void {
    const currentTime = Date.now();
    const cachedTime = this.localStorageService.get(this.lsKey()) ?? null;

    if (!cachedTime) return;

    const expirationInMs = this.lsExpirationInterval();
    const isIntervalElapsed = expirationInMs ? currentTime - cachedTime > expirationInMs : false;

    this.isDismissed.set(isIntervalElapsed ? null : cachedTime);
  }
}
